import React from 'react'
import Link from 'gatsby-link'
import styles from "./index.module.css"
import './theme.css'
import FlexContainer from "../components/flex-container.js";
import Helmet from 'react-helmet'
import Container from "../components/container";
import BtnHabitationDeQuebec from '../components/btn-habitation-de-quebec.js'
import BtnFrancoisDePontGrave from '../components/btn-francois-de-pont-grave.js'
import BtnMarcLescarbot from '../components/btn-marc-lescarbot.js'
import BtnLePalaisMontcalm from '../components/btn-le-palais-montcalm.js'
import BtnSymeon from '../components/btn-symeon.js'
import BtnHenrietteBelley from '../components/btn-henriette-belley.js'
import BtnLeBoulevardDeLaCapitale from '../components/btn-le-boulevard-de-la-capitale.js'
import BtnDinaBelanger from '../components/btn-dina-belanger.js'
import BtnEdouardFiset from '../components/btn-edouard-fiset.js'
import BtnLIlotFleurie from '../components/btn-l-ilot-fleurie.js'
import BtnMarieSavonnieresDeLaTroche from '../components/btn-marie-savonnieres-de-la-troche.js'
import BtnLouisFortier from '../components/btn-louis-fortier.js'
import BtnHabitationDesHurons from '../components/btn-habitation-des-hurons.js'
import BtnNicolasVincent from '../components/btn-nicolas-vincent.js'
import BtnGuySiouiDurand from '../components/btn-guy-sioui-durand.js'
import SvgLogo from '../../images/logo-ludovica.svg'
import Voiture1 from '../../images/voiture1.png'
import Voiture2 from '../../images/voiture2.png'
import ImagePlis from '../../images/plis.png'

const IndexPage = () => (
    <div style={{width: '100%', textAlign: 'center'}} className="interface">
        <Helmet bodyAttributes={{class: 'accueil'}}/>
        <div className="titre">
            <Link to="/a-propos/">
                <SvgLogo style={{color: '#fff'}}/>
            </Link>
        </div>
        <div className="voiture1" style={{position: "absolute", top: "36vw", left: "39vw"}}>
            <img src={Voiture1} alt=""/>
        </div>
        <div className="voiture2" style={{position: "absolute", top: "45vw", left: "54vw"}}>
            <img src={Voiture2} alt=""/>
        </div>
        <div className="plis" style={{position: "absolute", top: "0", left: "0", width: "100%", height: "auto"}}>
            <img src={ImagePlis} alt=""/>
        </div>
        <div style={{position: "absolute", top: "1.75vw", left: "3vw"}}>
            <BtnHabitationDeQuebec/>
        </div>
        <div style={{position: "absolute", top: "7.25vw", left: "30vw"}}>
            <BtnMarcLescarbot/>
        </div>
        <div style={{position: "absolute", top: "3.5vw", left: "52vw"}}>
            <BtnSymeon/>
        </div>
        <div style={{position: "absolute", top: "4.25vw", left: "70vw"}}>
            <BtnLePalaisMontcalm/>
        </div>
        <div style={{position: "absolute", top: "33vw", left: "1vw"}}>
            <BtnFrancoisDePontGrave/>
        </div>
        <div style={{position: "absolute", top: "36vw", left: "79vw"}}>
            <BtnHenrietteBelley/>
        </div>
        <div style={{position: "absolute", top: "46vw", left: "40vw"}}>
            <BtnLeBoulevardDeLaCapitale/>
        </div>
        <div style={{position: "absolute", top: "57vw", left: "8vw"}}>
            <BtnDinaBelanger/>
        </div>
        <div style={{position: "absolute", top: "76vw", left: "6vw"}}>
            <BtnEdouardFiset/>
        </div>
        <div style={{position: "absolute", top: "55vw", left: "75vw"}}>
            <BtnLIlotFleurie/>
        </div>
        <div style={{position: "absolute", top: "80vw", left: "51vw"}}>
            <BtnGuySiouiDurand/>
        </div>
        <div style={{position: "absolute", top: "84vw", left: "79vw"}}>
            <BtnLouisFortier/>
        </div>
        <div style={{position: "absolute", top: "107vw", left: "16vw"}}>
            <BtnHabitationDesHurons/>
        </div>
        <div style={{position: "absolute", top: "105vw", left: "44vw"}}>
            <BtnNicolasVincent/>
        </div>
        <div style={{position: "absolute", top: "110vw", left: "65vw"}}>
            <BtnMarieSavonnieresDeLaTroche/>
        </div>
    </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js